"use client";
import React, { useEffect } from "react";
import classNames from "classnames";
import { useLocale } from "next-intl";

import { useTheme } from "@/context/Theme.context";
import { ShowWhen } from "@/components/common";
import SidebarMenu from "./sidebar-menu/sidebar-menu";
import SidebarFooter from "./footer/footer";
import { BoxetteLogoLight, EasyXpressLogo2 } from "@/components/assets/icons";
import { Theme } from "@/enums";

const Sidebar = () => {
  const theme = useTheme();
  const locale = useLocale();

  return (
    <aside
      className={classNames(
        "fixed left-0 top-0 z-[1] hidden h-full w-full max-w-[25%] p-8 lg:block",
        {
          sidebar: theme === Theme.GEORGIA || theme === Theme.UZ,
          "sidebar-uk": theme === Theme.UK,
        },
      )}
    >
      <div className="flex h-full w-full max-w-[66%] flex-col justify-between">
        <div>
          <div className="mr-[7.875rem]">
            <ShowWhen
              condition={theme === Theme.GEORGIA || theme === Theme.UZ}
              elseRender={
                <a href={`https://easyxpress.com.ua/${locale}`}>
                  <EasyXpressLogo2 className="h-[2.125rem]" />
                </a>
              }
            >
              <BoxetteLogoLight className="h-[2.125rem] w-[8.75rem]" />
            </ShowWhen>
          </div>
          <div className="my-8 h-px w-full bg-white opacity-10" />
          <SidebarMenu />
        </div>
        <SidebarFooter />
      </div>
    </aside>
  );
};

export default Sidebar;
